<template>
  <DDTDettaglio
    :num_ddt="num_ddt"
    :id_ddt="id_ddt"
  />
</template>

<script>
import DDTDettaglio from '@/components/MAGAZZINO/DDTDettaglio.vue';

export default {
  name: 'DDTDettaglioView',
  props: ['num_ddt', 'id_ddt'],
  components: {
    DDTDettaglio,
  },
}
</script>